<block-ui></block-ui>
  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <!-- begin::Header -->
    <div class="card card-custom-h">
      <!-- begin::Body -->
      <div class="card-body py-3">
        <!-- begin::Table container -->
        <div class="table-responsive">
          <!-- begin::Table -->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Modified")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

              <tr *ngFor="let Log of LogsPagingResult">
                <td>
                  <a class="text-gray-800 text-hover-primary mb-1" (click)="showFileDataModal(Log.pathEncrypted,Log.name,ViewFileModal)">{{Log.name}}</a>
                </td>
                <td>
                  {{Log.lastModified}}
                </td>
              </tr>
              <tr *ngIf="LogsPagingResult.length == 0">
                <td colspan="2">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>
          <!--end::Permission list-->
        </div>

      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setPublicHolidayListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="LogsPaging" #LogsPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>
  </div>

  <!-- View file Modal -->
  <ng-template #ViewFileModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{FileName}}</h1>
      </div>

      <form [formGroup]="ViewFileForm">
        <BBSF-TextArea [options]="ViewFileData" [group]="ViewFileForm">
        </BBSF-TextArea>
        <div class="text-center pt-7">
          <button #CloseViewFileModal id="CloseViewFileModal" type="button"
                  class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>

        </div>
      </form>
    </div>
  </ng-template>
